import CloseIcon from "@mui/icons-material/Close";
import { useMountEffect } from "@react-hookz/web";
import React, { Suspense, useState } from "react";
import { useSdkContext } from "~/components/contexts";
import { useIsNotificationSupported } from "./hooks";
import ChevronLeftIcon from "./icon-chevron-left.svg";
import NotificationIcon from "./icon-notification.svg";
import { NotificationInstruction } from "./notification-instruction";
import { NotificationList } from "./notification-list";
import { NotificationSetting } from "./notification-setting";
import { AlertButton, AlertTitle, BackButton, Header, InstructionCloseButton, InstructionContainer, ListContainer, Loading, NotificationTitle, SettingContainer } from "./styles";
export const NotificationPanel = ({
  notificationListQuery
}) => {
  const [currentTab, setCurrentTab] = useState("list");
  const {
    isNotificationSupported
  } = useIsNotificationSupported();
  const {
    handleTrackGA,
    handleTrackGA4
  } = useSdkContext();
  useMountEffect(() => {
    handleTrackGA({
      action: "Article recommend/Notification/Impression",
      category: "Article recommend - Notification centre",
      label: ""
    });
    handleTrackGA4({
      action: "imp",
      category: "noticenter",
      customized_parameters: undefined,
      subcategory: ""
    });
  });
  switch (currentTab) {
    case "list":
      return /*#__PURE__*/React.createElement(ListContainer, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(NotificationTitle, null, "Notifications"), /*#__PURE__*/React.createElement(AlertButton, {
        onClick: () => {
          handleTrackGA({
            action: "My Account/Overlay/Notification/Alerts/Click",
            category: "My Account",
            label: ""
          });
          setCurrentTab("setting");
        }
      }, /*#__PURE__*/React.createElement(NotificationIcon, null), "Alerts")), /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement(Loading, {
          color: "inherit"
        })
      }, notificationListQuery && /*#__PURE__*/React.createElement(NotificationList, {
        queryReference: notificationListQuery
      })));
    case "setting":
      return /*#__PURE__*/React.createElement(SettingContainer, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(BackButton, {
        onClick: () => setCurrentTab("list")
      }, /*#__PURE__*/React.createElement(ChevronLeftIcon, {
        fontSize: "inherit"
      })), /*#__PURE__*/React.createElement(AlertTitle, null, "Alerts")), /*#__PURE__*/React.createElement(NotificationSetting, {
        isNotificationSupported: isNotificationSupported,
        onPermissionDenied: () => setCurrentTab("instructions")
      }));
    case "instructions":
      return /*#__PURE__*/React.createElement(InstructionContainer, null, /*#__PURE__*/React.createElement(InstructionCloseButton, {
        "aria-label": "close",
        onClick: () => setCurrentTab("setting")
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        color: "inherit"
      })), /*#__PURE__*/React.createElement(NotificationInstruction, null));
  }
};
NotificationPanel.displayName = "NotificationPanel";